
/**
 * 추가 메타데이터
 */
export type CreateSubscriptionSessionBodyMetadata = { [key: string]: unknown };
